import service from '@/utils/request';

// 登录场景配置列表

export var xingxingList = function xingxingList(data) {
  return service({
    url: "/xcpGameData/xingxing/xingxingList",
    method: 'post',
    data: data
  });
};
export var xingxingListAll = function xingxingListAll(data) {
  return service({
    url: "/xcpGameData/xingxing/xingxingListAll",
    method: 'post',
    data: data
  });
};